import { config } from '@things-factory/env'
import { getEndpointUrl } from '../utils/config-resolver.js'

import debugLib from 'debug'
const debug = debugLib('things-factory:dataset:shiny-report')
const dataReportConfig = config.get('dataReport')
const {
  shiny: {
    endpoint: ENDPOINT,
    datasource: { database: DATABASE }
  }
} = Object.assign(
  {
    shiny: {
      endpoint: {},
      datasource: {}
    }
  },
  dataReportConfig
)

export async function renderShinyReport(context: any) {
  debug('render:context', context)

  try {
    const cookies = new URLSearchParams(context.header.cookie.replace(/; /g, '&'))
    const token = cookies.get('access_token')
    const {
      state: { domain },
      query,
      response
    } = context

    const urlParams = new URLSearchParams({
      token,
      ...query,
      database: DATABASE,
      domain: domain?.subdomain
    }).toString()

    const subpath = query?.reportView || ''

    if (!subpath) {
      return (context.body = '')
    }

    const url = getEndpointUrl(ENDPOINT, subpath)
    const reportUrl = `${url}/?${urlParams}`

    response.redirect(reportUrl)
  } catch (ex) {
    context.body = `Error: ${ex.message} || ''`
  }
}
